import { Component, Input, OnInit } from '@angular/core';
import { ModalComponent } from '../../../../config/core.modal-helpers';
import { KnowledgeIndexAdminService } from './knowledge-index-admin.service';
import { UiService } from '../../../../services/core.ui.service';
import { KiSection } from './knowledge-index.types';

@Component({
    selector: 'knowledge-index-queue-modal',
    template: require('./knowledge-index-queue-modal.component.html'),
})
export class KnowledgeIndexQueueModalComponent extends ModalComponent implements OnInit {

    @Input() projectId: number;
    @Input() sections: KiSection[] = [];

    selected: { [section: string]: boolean } = {};
    saving = false;

    constructor(
        private kiService: KnowledgeIndexAdminService,
        private uiService: UiService,
    ) { super(); }

    ngOnInit() {
        this.sections.forEach(s => {
            this.selected[s.section] = s.enabled;
        });
    }

    get selectedSections(): string[] {
        return Object.keys(this.selected).filter(k => this.selected[k]);
    }

    get canSubmit(): boolean {
        return !this.saving && this.selectedSections.length > 0;
    }

    toggleSection(section: string, value: boolean) {
        this.selected[section] = value;
    }

    submit() {
        if (!this.canSubmit) { return; }
        this.saving = true;
        this.kiService.queueIndex(this.projectId, { sections: this.selectedSections })
            .then(() => {
                this.saving = false;
                this.uiService.message.showSuccess('Queued for indexing.');
                this.closeModal(true);
            })
            .catch(err => {
                this.saving = false;
                this.uiService.message.showError(
                    (err && err.error && err.error.message) || 'Failed to queue indexing job'
                );
            });
    }

    cancel() {
        this.closeModal(false);
    }
}
